<div class="cards-data">
  <p>{{ sectionLabel }}</p>

  <div class="inputs-card">
    <div class="add-device">
      <mat-form-field>
        <mat-label>Nome do novo dispositivo</mat-label>
        <input matInput [formControl]="formNewItem"/>
        @if (formNewItem.hasError('required')) {
          <mat-error>Nome do novo dispositivo é obrigatório</mat-error>
        }
      </mat-form-field>
      <div class="btn-add">
        <img src="assets/img/add.png" alt="add" (click)="add()"/>
      </div>
    </div>

    @for (device of form().controls; track $index) {
      <div class="input-list">
        <mat-form-field>
          <mat-label>Nome do dispositivo</mat-label>
          <input matInput [formControl]="device.controls.name"/>
          @if (device.controls.name.hasError('required')) {
            <mat-error>Nome do novo dispositivo é obrigatório</mat-error>
          }
        </mat-form-field>

        <div class="btn-add">
          <img
            class="edit"
            src="assets/img/edit.png"
            alt="add"
            (click)="edit($index)"
          />
          <img
            src="assets/img/delete.png"
            alt="delete"
            (click)="delete($index)"
          />
        </div>
      </div>
    } @empty {
      <div class="empty">
        <p>Não existe dispositivos cadastrados</p>
      </div>
    }
  </div>
</div>
